import { createContext, use, useEffect, useState, type ReactNode } from 'react';
import { readStudioSnapshot, watchStudioPresence } from './studioPresencePoller';
import './studio-presence.css';
import './studio-presence-integration.css';

const EMPTY: ReadonlySet<number> = new Set();
const StudioContext = createContext<ReadonlySet<number>>(EMPTY);

export function StudioPresenceProvider({ children }: { children: ReactNode }) {
  const [present, setPresent] = useState(EMPTY);
  useEffect(() => watchStudioPresence(setPresent, async signal => {
    const response = await fetch('/api/attendance-v2/presence', {
      credentials: 'same-origin', cache: 'no-store', signal,
    });
    if (!response.ok) throw new Error('Studio presence unavailable');
    return readStudioSnapshot(await response.json());
  }), []);
  return <StudioContext value={present}>{children}</StudioContext>;
}

export function useStudioPresence(userId?: number | null) {
  return use(StudioContext).has(userId ?? 0);
}

// Used by directory portraits which have their own accepted avatar layout.
export function StudioAvatarSurface({ userId, className, children }: {
  userId?: number;
  className: string;
  children: ReactNode;
}) {
  const present = useStudioPresence(userId);
  return <span className={`${className} studio-avatar-surface${present ? ' is-at-studio' : ''}`}
    title={present ? 'На студии (по отметкам посещаемости)' : undefined}>{children}</span>;
}
